import "isomorphic-fetch";

class ApiCalls {
  constructor() {
    this.state = {
      password: "",
      email: "",
      email_1: "",
      otp: "",
      passwd: "",
      cnfrmpasswd: "",
      passwordShow: false,
      modalIsOpen: false,
      forGotPassStep1: false,
      forGotPassStep2: false,
      forGotPassStep3: false,
      successPaymentModal: false,
      emailErr: "",
      passErr: "",
      forgotErr: "",
      modalActive: false,
      activationkeyerror: "",
      scrolling: false
    };
    this.chkotp = 0;
  }
  // select plan api calls
  getplan = () => {
    return fetch("api/backend/plan/");
  };

  getIntercom = () => {
    fetch("api/backend/intercom/", {
      method: "get"
    })
      .then(resp => {
        return resp.json();
      })
      .then(json => {
        if (json.error !== undefined || json.error === false) {
          window.Intercom("boot", {
            app_id: "nn9zsi9c",
            name: json["full_name"],
            email: json["email"],
            user_hash: json["user_hash"],
            created_at: json["created_at"]
          });
        }
      });
  };

  freeLicense = () => {
    // this.setState({ loading: true });
    return fetch("api/stripe/free_license/", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({})
    }).then(resp => {
      // return resp.json();
    });
    // this.context.router.history.push("/selectenvironment")
  };
  isLogin = () => {
    fetch("api/user/islogin/", {
      method: "get",
      headers: { "Content-Type": "application/json" }
    }).then(resp => {
      if (resp !== undefined && resp.response.error === false) {
        this.context.router.history.push("/profile");
      }
    });
  };

  // select region api calls

  getIntercomRegion = () => {
    return fetch("api/backend/intercom/", {
      method: "get"
    }).then(json => {
      if (json.error !== undefined || json.error === false) {
        window.Intercom("boot", {
          app_id: "nn9zsi9c",
          name: json["full_name"],
          email: json["email"],
          user_hash: json["user_hash"],
          created_at: json["created_at"]
        });
      }
    });
  };

  getLicenseKey = () => {
    // return fetch("api/stripe/license_key/?id=0", {
    //   method: "get",
    // }).then((resp) => {
    //   return resp.json();
    // });
  };

  getProfile = () => {
    return fetch("api/user/profile/", {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  };

  getLicenseInfo = () => {
    return fetch("api/backend/licInfo", {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  };

  getSubClientInfo = companyId => {
    let data = { companyId: companyId };
    return fetch("api/backend/subClientInfo", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  };

  getCardDetail = () => {
    return fetch("api/stripe/getCard/", {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  };

  getcountry = () => {
    return fetch("api/backend/countries/", {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  };

  getState = name => {
    return fetch("api/backend/state/?name=" + name, {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  };

  getBillState = name => {
    return fetch("api/backend/state/?name=" + name, {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  };

  getCity = name => {
    return fetch("api/backend/city/?name=" + name, {
      method: "get",
      header: { "Content-Type": "application/json" }
    });
  };

  getBillcity = name => {
    return fetch("api/backend/city/?name=" + name, {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  };

  // select environment api calls

  getIntercomEnv = () => {
    return fetch("api/backend/intercom/", {
      method: "get"
    }).then(json => {
      if (json && (json.error !== undefined || json.error === false)) {
        window.Intercom("boot", {
          app_id: "nn9zsi9c",
          name: json["full_name"],
          email: json["email"],
          user_hash: json["user_hash"],
          created_at: json["created_at"]
        });
      }
      return json;
    });
  };

  getLicencekeyEnv = () => {
    return fetch("api/stripe/license_key/?id=0", {
      method: "get"
    });
  };

  handleCodeSubmission(e) {
    let data = {
      email: this.state.email,
      activation_key: this.state.activation_code,
      password: this.state.password
    };
    return fetch("api/user/verify/activationkey/", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  handleSubmit() {
    const data = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      email: this.state.email,
      company: this.state.companyName,
      password: this.state.password,
      phone_number: this.state.phone,
      cloud_service: this.cloudService
    };
    return fetch("api/user/registration/", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  // login apis

  PasswordRestorelogin() {
    let data = {
      password: this.state.passwd,
      email: this.state.email_1,
      activation_key: this.state.otp
    };
    return fetch("api/user/forgotpassword/", {
      method: "put",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  getPassword() {
    let data = { activation_key: this.state.otp, email: this.state.email_1 };
    fetch("api/user/verify/email/", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  getMemberInfo() {
    return fetch("api/backend/userinfo", {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  }

  isExistingMember(data) {
    return fetch("api/backend/checkMember", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  sendInvitation(data) {
    return fetch("api/backend/inviteMember", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  cancelInvitation(data) {
    return fetch("api/backend/cancelInvite", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  updateEnvironment = data => {
    return fetch("api/backend/updateenv", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  };

  updateCurrentVersion = params => {
    return fetch("api/upgrade/updateVersion", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(params)
    });
  };

  getCurrentVersion = () => {
    return fetch("api/upgrade/versionInfo", {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  };

  fetchTimeZoneInfo(userId) {
    return fetch("api/backend/getTimezone", {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  }

  saveInviteeDetail(data) {
    return fetch("api/user/continueRegistration", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  resendVerificationCode(data) {
    return fetch("api/user/resendVerificationMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  createCharge(data) {
    return fetch("api/stripe/charge/", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  createSetupIntent() {
    return fetch("api/stripe/setupIntent/", {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  }

  fetchCard() {
    return fetch("api/stripe/fetchCard/", {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  }

  fetchBank() {
    return fetch("api/stripe/fetchBank/", {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  }

  attchPaymentMethod(data) {
    return fetch("api/stripe/attachCustomer/", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  addBankAccount(data) {
    return fetch("api/stripe/bankAccount/", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  getInvoicesList(data) {
    return fetch("api/backend/fetchInvoice", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  logInvoice(data) {
    return fetch("api/tracking/logInvoice", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  logTabData(data) {
    return fetch("api/tracking/logTabData", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  detachPaymentMethod(data) {
    return fetch("api/stripe/detachPaymentMethod", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  makeDefaultPaymentMethod(data) {
    return fetch("api/stripe/updateDefaultPaymentMethod", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  fetchCredits(data) {
    return fetch("api/license/fetchCredits", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  fetchResources(data = "") {
    let url = "api/license/fetchResources";
    if (data !== "") {
      url = url + `/${data.version}`;
    }
    return fetch(url, {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  }

  fetchCustomBuildResources(data = "") {
    let url = "api/upgrade/fetchCustomBuild";
    if (data !== "") {
      url = url + `/${data.version}`;
    }
    return fetch(url, {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  }

  fetchVersion() {
    let url = "api/upgrade/versionList";
    return fetch(url, {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  }

  fetchVersionOptions(version) {
    let url = "api/upgrade/versionOptions/" + version;
    return fetch(url, {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  }

  postVersionOptions(data) {
    return fetch("api/upgrade/versionOptions", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  confirmEmail(token, type) {
    let url = `api/user/confirmEmail?token=${token}&type=${type}`;
    return fetch(url, {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  }

  releaseNotes(version) {
    let url = `api/upgrade/releaseNotes?version=${version}`;
    return fetch(url, {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  }

  fetchNumberOfLicenses(params) {
    let url = `api/license/subLicenseAllowance?company_id=${params.company_id}`;
    return fetch(url, {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  }

  generateSubLicense(data) {
    return fetch("/api/license/createLicense", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  trackDownload(data) {
    return fetch("/api/upgrade/trackDownload", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });
  }

  getDiagnosticUrls = () => {
    return fetch("/api/upgrade/diagnostics", {
      method: "get",
      headers: { "Content-Type": "application/json" }
    });
  };
}

const service = new ApiCalls();
export default service;



// WEBPACK FOOTER //
// ./src/components/apis/api-calls.js